export const unitsdata = [
	{
		"id":1,
		"name": "Pièces",
		"code": "PCS",
		"status": "Active",
		
	},
	{
        "id":2,
		"name": "Kilogram",
		"code": "KG",
		"status": "Active",
		
	},
	{
        "id":3,
		"name": "PAX",
		"code": "PAX",
		"status": "Active",
		
	},
		{
        "id":4,
		"name": "Coffret",
		"code": "COFFRET",
		"status": "Active",
		
	},
	{
        "id":5,
		"name": "Litre",
		"code": "L",
		"status": "Active",
		
	}
	
]